module.exports = __webpack_public_path__ + "img/auth-fb.154108ca.svg";